import React, { useMemo, useState } from 'react';
import { getProductGallery } from '../utils/productGallery';
import { buildProductGalleryItems } from '../utils/productMedia';
import { t } from '../utils/i18n';

export default function ProductGallery({ slug, language, productName, product }) {
  const items = useMemo(() => {
    if (product) {
      return buildProductGalleryItems(product, slug, language);
    }
    return getProductGallery(slug).map((item) => ({
      src: item.src,
      alt: t(item.altKey, language)
    }));
  }, [product, slug, language]);

  const [activeIndex, setActiveIndex] = useState(0);

  const safeIndex = Math.min(activeIndex, Math.max(0, items.length - 1));
  const active = items[safeIndex];

  if (!active) return null;

  return (
    <div className="product-gallery">
      <div className="product-gallery-main">
        <img
          src={active.src}
          alt={active.alt}
          className="product-gallery-main-img"
        />
      </div>
      {items.length > 1 && (
        <div className="product-gallery-thumbs" role="tablist" aria-label={productName}>
          {items.map((item, index) => (
            <button
              key={item.src}
              type="button"
              role="tab"
              aria-selected={index === safeIndex}
              className={`product-gallery-thumb ${index === safeIndex ? 'is-active' : ''}`}
              onClick={() => setActiveIndex(index)}
            >
              <img src={item.src} alt="" className="product-gallery-thumb-img" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
